import ExpandableVideo from "@app/analytics/components/ExpandableVideo";
import PlayClip from "@app/analytics/components/PlayClip";
import type { FeedItem, FeedItemVideoClip } from "@app/analytics/Home/types";
import useSessionClip from "@app/analytics/hooks/recordings/useSessionClip";

import Stack from "@rui/Stack";

const HomeFeedItemVideoClip = ({
  entityId,
  session,
  videoClip,
}: {
  entityId: FeedItem["entityId"];
  session: FeedItem["session"];
  videoClip: FeedItemVideoClip;
}) => {
  const clip = useSessionClip({
    key: entityId,
    sessionId: session.id,
    clipStart: videoClip.startTime,
    clipEnd: videoClip.endTime,
  });

  if (!clip) return null;

  return (
    <Stack width="150px">
      <ExpandableVideo
        {...clip}
        containerSx={{ width: "150px", height: "90px" }}
        forcePauseOnMinimize
        maximizeOnPlay="always"
        renderMinimizedOverlay={(props) => (
          <PlayClip
            {...props}
            size="medium"
            sx={{ position: "absolute", bottom: "4px", right: "8px" }}
          />
        )}
      />
    </Stack>
  );
};

export default HomeFeedItemVideoClip;
